import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-20">
      <div className="container mx-auto px-[7.6923%]">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          {/* Company Info */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-6 group">
              <div className="w-12 h-12 bg-[#085041] flex items-center justify-center group-hover:bg-[#0A5F4C] transition-colors duration-400">
                <span className="text-[#E1F5EE] text-2xl font-bold">CX</span>
              </div>
              <span className="text-gray-900 text-2xl font-semibold tracking-tight">Sage</span>
            </Link>
            <p className="text-[18px] text-gray-600 leading-[1.6] mb-6">
              Building world-class customer experience departments for SaaS, eCommerce, and auction technology companies.
            </p>
            <div className="flex gap-4">
              <a 
                href="mailto:cxsagepro@gmail.com"
                className="bg-gray-200 p-3 hover:bg-[#00D4B4] hover:text-white transition-colors duration-400"
              >
                <Mail className="w-5 h-5" />
              </a>
              <a 
                href="#"
                className="bg-gray-200 p-3 hover:bg-[#00D4B4] hover:text-white transition-colors duration-400"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="#"
                className="bg-gray-200 p-3 hover:bg-[#00D4B4] hover:text-white transition-colors duration-400"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-[20px] font-semibold text-gray-900 mb-6">Quick Links</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/" className="text-[16px] text-gray-600 hover:text-[#00D4B4] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-[16px] text-gray-600 hover:text-[#00D4B4] transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/impact" className="text-[16px] text-gray-600 hover:text-[#00D4B4] transition-colors">
                  Business Impact
                </Link>
              </li>
              <li>
                <Link to="/awards" className="text-[16px] text-gray-600 hover:text-[#00D4B4] transition-colors">
                  Awards & Credentials
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[16px] text-gray-600 hover:text-[#00D4B4] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-[20px] font-semibold text-gray-900 mb-6">Services</h3>
            <ul className="space-y-4">
              <li><Link to="/services" className="text-[16px] text-gray-600 hover:text-[#00D4B4] transition-colors">Fractional COO & Ops Advisory</Link></li>
              <li><Link to="/services" className="text-[16px] text-gray-600 hover:text-[#00D4B4] transition-colors">Support Tech Stack Optimization</Link></li>
              <li><Link to="/services" className="text-[16px] text-gray-600 hover:text-[#00D4B4] transition-colors">Voice of Customer & De-Escalation</Link></li>
              <li><Link to="/services" className="text-[16px] text-gray-600 hover:text-[#00D4B4] transition-colors">AI-Powered Support</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[16px] text-gray-600">
              © {currentYear} CX Sage. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/feedback" className="text-[16px] text-gray-600 hover:text-[#00D4B4] transition-colors" data-testid="footer-feedback-link">
                Leave feedback
              </Link>
              <a href="#" className="text-[16px] text-gray-600 hover:text-[#00D4B4] transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-[16px] text-gray-600 hover:text-[#00D4B4] transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;